<template>
  <div class="modal fade delete-goal-current-modal" id="DeleteGoalsModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Deletar meta</h1>
                  <button type="button" class="btn-close delete-goal-current-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formDeleteUser" v-on:submit="deleteGoalMethod()">
                <div class="modal-body ps-30 pe-30">
                  <p>Quer realmente deletar a meta <strong>{{ getCurrentDeleteGoals.month }}/{{ getCurrentDeleteGoals.year }}</strong> no valor de R$ <strong>{{ getCurrentDeleteGoals.goal }}</strong> ?</p>
                  <p>se precisar desta meta no futuro, vai precisar criá-la novamente</p>
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="remote_path" class="form-label fw-medium"
                      >Senha do sistema</label
                    >
                    <input
                      type="password"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="password_user_delete"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiDeleteGoal" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageDeleteGoal">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger delete-goal-current-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonDeleteGoal" class="btn btn-dark">Deletar meta</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '../../config/axios.js';

export default {
  name: "DeleteGoalsModal",
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getCurrentDeleteGoals'
    ])
  },
  methods: {
    deleteGoalMethod(){
      event.preventDefault();

      if(
        document.getElementById("password_user_delete") == undefined ||
        document.getElementById("password_user_delete").value == ""
      ){
        this.alertResponse("Por favor preencha a senha", true);
        return;
      }

      const password_user_delete = document.getElementById("password_user_delete").value;
      const id_delete = this.getCurrentDeleteGoals.id;

      const objUserDelete = {
        "id": id_delete,
        "password": password_user_delete
      }

      const buttonDeleteGoal = this.$refs.buttonDeleteGoal;
      buttonDeleteGoal.disabled = true;
      buttonDeleteGoal.innerHTML = "Deletando...";
      const alertResponse = this.alertResponse;

        api.axios.post("/api/delete/goal", objUserDelete).catch(function(error){
          if(error.response.data != undefined){
            buttonDeleteGoal.innerHTML = "Deletar";
          }
          console.log("error", error);
          alertResponse(error.response.data, true);
        }).then(function(response){
          
          if(response != undefined && response.status == 200){
            buttonDeleteGoal.innerHTML = "Usuário deletada com sucesso !";
            window.location.reload();
          } else {
            buttonDeleteGoal.disabled = false;
            buttonDeleteGoal.innerHTML = "Deletar usuário";
            
            document.getElementById("password_user_delete").value = "";
          }
        });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageDeleteGoal").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageDeleteGoal").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiDeleteGoal");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }

      const password = document.getElementById("password_user_delete");
      if(password){
        password.value = "";
      }
    },
  }
};
</script>